import type { User } from '@libs/contexts';
import { ui } from '@libs/domain';
import { IconButton } from '@mui/material';
import { useItemName } from '@ps-smart-cp/ppfw-client';
import { useLocation } from 'react-router-dom';
import { getUserCookie } from '../services';
import { globalAreaButtonFont, nonOverflowText } from '../styles';
import { Arrow } from './Arrow';

interface CompanyButtonProps {
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
  user: User;
  isUnderSubsystem: boolean;
}

function CompanyButton(props: CompanyButtonProps) {
  const { user, isUnderSubsystem, anchorEl, setAnchorEl } = props;
  const { pathname } = useLocation();
  const userCookie = getUserCookie();
  const getName = useItemName();

  return (
    <IconButton
      id="company-panel"
      disableTouchRipple
      onClick={(e) => setAnchorEl(e.currentTarget)}
      sx={{
        ...globalAreaButtonFont,
        borderRadius: '0%',
        marginTop: '2px',
        width: '200px',
        display: 'flex',
        justifyContent: !isUnderSubsystem ? 'center' : 'space-between',
      }}
    >
      {!isUnderSubsystem ? (
        <div style={{ ...nonOverflowText, maxWidth: '180px' }}>{getName(ui.linkNames.selectCompany)}</div>
      ) : (
        <>
          <div style={{ ...nonOverflowText, maxWidth: '180px', marginRight: 'auto' }}>
            {user.availableCompanies.find((a) => a.code === userCookie.company_code)?.name}
          </div>
          <div>{pathname.split('/')[1].toUpperCase()}</div>
        </>
      )}
      <Arrow open={!!anchorEl} />
    </IconButton>
  );
}

export { CompanyButton };
